import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { thirdly } from 'styles/theme';
import { dark } from 'styles/theme';
import Annotation from 'chartjs-plugin-annotation';
import { fontFamily } from '@mui/system';

ChartJS.register(CategoryScale, LinearScale, Annotation, BarElement, Title, Tooltip, Legend);

const BarChart = (props) => {
    const { data, yLabel, labelsPerBar, markType } = props

    const labels = data?.current.map(item => item.grade_name)
    const prevLabels = data?.prev.map(item => item.grade_name)

    const markTypeKeys = {
        "median": "חציון",
        "avg": "ממוצע"
    }

    const assessmentCount = useMemo(
        () => [
            data?.prev.map(item => item.assessment_count),
            data?.new_prev.map(item => item.assessment_count),
            data?.current.map(item => item.assessment_count),
            data?.new_current.map(item => item.assessment_count)
        ], [data]
    )

    const datasets = useMemo(
        () => [
            {
                data: data?.prev.map(item => item[markType]),
                backgroundColor: [
                    thirdly,
                    thirdly,
                    thirdly,
                ],
                borderWidth: 1,
                year: 2024
            },
            {
                data: data?.new_prev.map(item => item[markType]),
                backgroundColor: [
                    "#F6F6F6",
                    "#F6F6F6",
                    "#F6F6F6",
                ],
                borderWidth: 1,
                year: 2024
            },
            {
                data: data?.current.map(item => item[markType]),
                backgroundColor: [
                    dark,
                    dark,
                    dark,
                ],
                borderWidth: 1,
                year: 2025
            },
            {
                data: data?.new_current.map(item => item[markType]),
                backgroundColor: [
                    "#F6F6F6",
                    "#F6F6F6",
                    "#F6F6F6",
                ],
                borderWidth: 1,
                year: 2025
            }
        ], [data]
    )

    const dataValues = {
        labels: data?.current.map(item => item.grade_name),
        datasets: datasets
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                title: {
                    display: true,
                    text: yLabel,
                    font: {
                        family: [
                            "Calibri", "sans-serif"
                        ].join(','),
                        size: 16
                    },
                },
                ticks: {
                    stepSize: 10, // Adjust step size to ensure all values are visible
                },
            },
            x: {
                ticks: {
                    stepSize: 10,
                    font: {
                        size: 14
                    }
                }
            }
        },
        plugins: {
            labels: {
                display: "none",
            },
            datalabels: {
                display: true,
                color: 'black',
                anchor: 'start',
                align: 'start',
                rotation: 45,
                font: {
                    size: 12,
                },
                formatter: function (value, context) {
                    return labelsPerBar[context.datasetIndex][context.dataIndex];
                }
            },
            datalabels: {
                display: false
            },
            legend: {
                display: false
            },
            title: {
                display: false,
            },
            tooltip: {
                displayColors: false,
                callbacks: {
                    beforeBody: function (tooltipItem) {
                        let { raw } = tooltipItem?.[0] || {};
                        return `${markTypeKeys[markType]}: ${raw?.toFixed(1)}`;
                    },
                    afterTitle: function (tooltipItem) {
                        let { dataset } = tooltipItem?.[0] || {};
                        return `שנת לימודים: ${dataset?.year}`;
                    },
                    label: function (tooltipItem) {
                        const { dataIndex, datasetIndex } = tooltipItem
                        return `${assessmentCount[datasetIndex][dataIndex]} מבדקים`;
                    },
                    title: function (tooltipItem) {
                        const { dataIndex, datasetIndex } = tooltipItem[0]
                        return `שכבה בעת ביצוע: ${datasetIndex > 1 ? labels[dataIndex] : prevLabels[dataIndex]}`;
                    },
                }
            },
        },
    };

    return <Bar key={"bar-chart"} data={dataValues} options={options} />;
};

export default BarChart;